import { X, Check } from "lucide-react";

export type SortOption = 
  | "newest"
  | "oldest"
  | "price-low"
  | "price-high"
  | "brand-az";

interface SortSheetProps {
  isOpen: boolean;
  onClose: () => void;
  currentSort: SortOption;
  onSortChange: (sort: SortOption) => void;
}

const sortOptions = [
  { value: "newest" as SortOption, label: "Mais recentes" },
  { value: "oldest" as SortOption, label: "Mais antigos" },
  { value: "price-low" as SortOption, label: "Menor preço" },
  { value: "price-high" as SortOption, label: "Maior preço" },
  { value: "brand-az" as SortOption, label: "Marca (A-Z)" },
];

export function SortSheet({ isOpen, onClose, currentSort, onSortChange }: SortSheetProps) {
  if (!isOpen) return null;

  const handleSortSelect = (sort: SortOption) => {
    onSortChange(sort);
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50 animate-in fade-in"
        onClick={onClose}
      />
      
      {/* Bottom Sheet */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-card rounded-t-3xl shadow-2xl animate-in slide-in-from-bottom duration-300">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl">Ordenar por</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-secondary rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Sort Options */}
        <div className="p-4 pb-8">
          {sortOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => handleSortSelect(option.value)}
              className={`w-full flex items-center justify-between p-4 rounded-lg hover:bg-secondary/50 transition-colors ${
                currentSort === option.value ? "bg-secondary" : ""
              }`}
            >
              <span className={currentSort === option.value ? "font-medium" : ""}>
                {option.label}
              </span>
              {currentSort === option.value && (
                <Check className="w-5 h-5 text-primary" />
              )}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
